export * from './simple-layout.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/containers/simple-layout/index.ts